// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"41083880","453":"99ded463","455":"9b02cf7c"}[chunkId] + ".chunk.js";
};